import 'react-datepicker/dist/react-datepicker.css';
import { Box, FormControl, Input, Textarea, FormLabel, FormHelperText, useColorModeValue } from '@chakra-ui/react';

// Assets
import { formatDate, parseDateBirthday } from 'services/Utils';

// Components
import { DateTimeInputIcon } from 'components/Icons/Icons';

const EditField = ({ 
  id, 
  label, 
  type = 'text', 
  value, 
  editMode,
  isActive,
  isValid, 
  onChange, 
  placeholder = '',
  mt,
  mb,
  display,
  ...restProps
}) => {
  const editLineBgDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBgWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBg = useColorModeValue(editLineBgWhite, editLineBgDark);

  return (
    <FormControl variant={editMode ? 'floating' : 'calm'} id={id} mt={mt} mb={mb} display={display}>
      {type === 'textarea' ? (
        <Textarea
          value={value}
          resize="none"
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          h={{ base: '226.5px !important' }}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      ) : (
        <Input
          value={type === 'datetime-local' ? formatDate(value) : type === 'date' ? parseDateBirthday(value) : value}
          type={type}
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      )}
      <FormLabel
        htmlFor={id}
        className={isValid ? 'input-valid' : 'input-invalid'}
      >
        {label}
      </FormLabel>
      <FormHelperText
        className={isValid ? 'hidden' : 'input-error'}
      >
        Input invalid
      </FormHelperText>

      { (type === 'datetime-local' || type === 'date') && editMode && (
        <DateTimeInputIcon 
          fontSize="24px"
          position="absolute"
          right="15px"
          top="15px"
          color="#9FABCB"
          pointerEvents="none"
          zIndex="1"
        />
      )}

      { editMode && (
          <Box
            zIndex="1"
            transition="0.2s all"
            opacity={ value?.length > 0 ? '1' : '0'}
            w="100%"
            position="absolute"
            bottom="0"
            h="2px" 
            bg={editLineBg} />
      )}
    </FormControl>
  );
};

export default EditField;